var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFormCrear(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-form-crear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 9,
    transform: "translate(-329.000000, -248.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabla",
    transform: "translate(298.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-form-crear",
    transform: "translate(31.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.78125,17 L10.21875,17 C9.5468125,17 9,16.2148333 9,15.25 L9,11.75 C9,10.7851667 9.5468125,10 10.21875,10 L20.78125,10 C21.4531875,10 22,10.7851667 22,11.75 L22,15.25 C22,16.2148333 21.4531875,17 20.78125,17 Z M10.3928571,11 C10.176,11 10,11.224 10,11.5 L10,14.5 C10,14.776 10.176,15 10.3928571,15 L20.6071429,15 C20.824,15 21,14.776 21,14.5 L21,11.5 C21,11.224 20.824,11 20.6071429,11 L10.3928571,11 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,16.25 C1.45816667,16.25 0,14.7918333 0,13 C0,11.2081667 1.45816667,9.75 3.25,9.75 C5.04183333,9.75 6.5,11.2081667 6.5,13 C6.5,14.7918333 5.04183333,16.25 3.25,16.25 Z M3.25,10.8333333 C2.05508333,10.8333333 1.08333333,11.8050833 1.08333333,13 C1.08333333,14.1949167 2.05508333,15.1666667 3.25,15.1666667 C4.44491667,15.1666667 5.41666667,14.1949167 5.41666667,13 C5.41666667,11.8050833 4.44491667,10.8333333 3.25,10.8333333 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.78125,6 L10.21875,6 C9.5468125,6 9,5.327 9,4.5 L9,1.5 C9,0.673 9.5468125,4.4408921e-16 10.21875,4.4408921e-16 L20.78125,4.4408921e-16 C21.4531875,4.4408921e-16 22,0.673 22,1.5 L22,4.5 C22,5.327 21.4531875,6 20.78125,6 Z M10.3928571,1 C10.176,1 10,1.224 10,1.5 L10,4.5 C10,4.776 10.176,5 10.3928571,5 L20.6071429,5 C20.824,5 21,4.776 21,4.5 L21,1.5 C21,1.224 20.824,1 20.6071429,1 L10.3928571,1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,6.5 C1.45816667,6.5 0,5.04183333 0,3.25 C0,1.45816667 1.45816667,0 3.25,0 C5.04183333,0 6.5,1.45816667 6.5,3.25 C6.5,5.04183333 5.04183333,6.5 3.25,6.5 Z M3.25,1.08333333 C2.05508333,1.08333333 1.08333333,2.05508333 1.08333333,3.25 C1.08333333,4.44491667 2.05508333,5.41666667 3.25,5.41666667 C4.44491667,5.41666667 5.41666667,4.44491667 5.41666667,3.25 C5.41666667,2.05508333 4.44491667,1.08333333 3.25,1.08333333 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFormCrear);
export default __webpack_public_path__ + "static/media/ico-form-crear.5be6ada19e7308ea66dbedaecf82bc78.svg";
export { ForwardRef as ReactComponent };